module.exports = __webpack_public_path__ + "img/7类3级.25e82bff.png";